import type { AgentInput } from '@24talk/shared';

// API responses contain server-owned fields. Never round-trip those into mutations.
export function toAgentInput(agent: AgentInput): AgentInput {
  return {
    displayName: agent.displayName,
    greeting: agent.greeting,
    ...(agent.defaultLocale !== undefined ? { defaultLocale: agent.defaultLocale } : {}),
    ...(agent.greetingId !== undefined ? { greetingId: agent.greetingId } : {}),
    ...(agent.greetingEn !== undefined ? { greetingEn: agent.greetingEn } : {}),
    instructions: agent.instructions,
    primaryColor: agent.primaryColor,
    isActive: agent.isActive,
    ...(agent.contactCaptureEnabled !== undefined
      ? { contactCaptureEnabled: agent.contactCaptureEnabled }
      : {}),
    ...(agent.humanHandoffEnabled !== undefined
      ? { humanHandoffEnabled: agent.humanHandoffEnabled }
      : {}),
    ...(agent.webSearchEnabled !== undefined ? { webSearchEnabled: agent.webSearchEnabled } : {}),
    ...(agent.allowedSearchDomains !== undefined
      ? { allowedSearchDomains: agent.allowedSearchDomains }
      : {}),
  };
}
